module.exports = __webpack_public_path__ + "static/media/TN-Women-Pants.7dfbbfe9.svg";